import { AllScales, UseCaseValues } from "../types";

const getColorScaleFromThemeObject = (
  scale: AllScales,
  useCase: UseCaseValues,
  themeObj
) => themeObj.colors[`${scale}${String(useCase)}`].value;
export default getColorScaleFromThemeObject;
